import React, {ReactNode} from 'react';

import {HintPremium, TariffBooleanLimit} from 'entities/tariff';
import {useTariffFlag} from 'entities/user';
import {getDomainCheckPlaceholder, getDomainCheckState} from 'features/domain/lib/domainCheckState';

import styles from './DomainCheckValue.module.scss';

interface IDomainCheckValueProps {
    tariffCondition: TariffBooleanLimit,
    isWatched: boolean,
    value: string | boolean | null | undefined,
    children: ReactNode,
}

const DomainCheckValue: React.FC<IDomainCheckValueProps> = ({
    tariffCondition,
    isWatched,
    value,
    children,
}) => {
    const isTariffEnabled = useTariffFlag(tariffCondition);

    if (!isTariffEnabled) {
        return <HintPremium condition={tariffCondition}/>;
    }

    const state = getDomainCheckState(isWatched, value);

    if (state === 'ready') {
        return <>{children}</>;
    }

    return <span className={styles.placeholder}>{getDomainCheckPlaceholder(state)}</span>;
};

export default DomainCheckValue;
